// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"351":"06669b415459a7f7bbf7","678":"83788a91344732148ff5","883":"dada404381c02952ce43","989":"3b9e5684f09f83e0d1f4"}[chunkId] + ".js";
};